/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.43.0(94c055bcbdd49f04a0fa15515e848542a79fb948)
 * Released under the MIT license
 * https://github.com/microsoft/vscode/blob/main/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/editor/editor.main.nls.zh-tw", {
	"vs/base/browser/ui/actionbar/actionViewItems": [
		"{0} ({1})",
	],
	"vs/base/browser/ui/findinput/findInput": [
		"輸入",
	],
	"vs/base/browser/ui/findinput/findInputToggles": [
		"大小寫須相符",
		"全字拼寫須相符",
		"使用規則運算式",
	],
	"vs/base/browser/ui/findinput/replaceInput": [
		"輸入",
		"保留案例",
	],
	"vs/base/browser/ui/hover/hoverWidget": [
		"Inspect this in the accessible view with {0}.",
		"Inspect this in the accessible view via the command Open Accessible View which is currently not triggerable via keybinding.",
	],
	"vs/base/browser/ui/iconLabel/iconLabelHover": [
		"正在載入...",
	],
	"vs/base/browser/ui/inputbox/inputBox": [
		"錯誤: {0}",
		"警告: {0}",
		"資訊: {0}",
		"歷程記錄",
		"已清除輸入",
	],
	"vs/base/browser/ui/keybindingLabel/keybindingLabel": [
		"未繫結",
	],
	"vs/base/browser/ui/selectBox/selectBoxCustom": [
		"選取方塊",
	],
	"vs/base/browser/ui/toolbar/toolbar": [
		"更多操作",
	],
	"vs/base/browser/ui/tree/abstractTree": [
		"篩選",
		"模糊比對",
		"要篩選的類型",
		"要搜尋的類型",
		"要搜尋的類型",
		"關閉",
		"找不到任何元素。",
	],
	"vs/base/common/actions": [
		"(空的)",
	],
	"vs/base/common/errorMessage": [
		"{0}: {1}",
		"發生系統錯誤 ({0})",
		"發生未知的錯誤。如需詳細資訊，請參閱記錄檔。",
		"發生未知的錯誤。如需詳細資訊，請參閱記錄檔。",
		"{0} (總計 {1} 個錯誤)",
		"發生未知的錯誤。如需詳細資訊，請參閱記錄檔。",
	],
	"vs/base/common/keybindingLabels": [
		"Ctrl",
		"Shift",
		"Alt",
		"Windows",
		"Ctrl",
		"Shift",
		"Alt",
		"超級鍵",
		"Control",
		"Shift",
		"選項",
		"命令",
		"Control",
		"Shift",
		"Alt",
		"Windows",
		"Control",
		"Shift",
		"Alt",
		"超級鍵",
	],
	"vs/base/common/platform": [
		"_",
	],
	"vs/editor/browser/controller/textAreaHandler": [
		"編輯器",
		"目前無法存取此編輯器。",
		"{0} 若要啟用螢幕助讀程式最佳化模式，請使用 {1}",
		"{0} 若要啟用螢幕助讀程式最佳化模式，，請使用 {1} 開啟快速挑選，然後執行 [切換螢幕助讀程式協助工具模式] 命令，該模式目前無法透過鍵盤觸發。",
		"{0} 請使用 {1} 存取按鍵繫結關係編輯器並加以執行，以為 [切換螢幕助讀程式協助工具模式] 命令指派按鍵繫結關係。",
	],
	"vs/editor/browser/coreCommands": [
		"即使行的長度過長，仍要堅持至結尾",
		"即使行的長度過長，仍要堅持至結尾",
		"已移除次要資料指標",
	],
	"vs/editor/browser/editorExtensions": [
		"復原(&&U)",
		"復原",
		"取消復原(&&R)",
		"重做",
		"全選(&&S)",
		"全選",
	],
	"vs/editor/browser/widget/codeEditorWidget": [
		"游標數目已限制為 {0}。請考慮使用 [尋找和取代](https://code.visualstudio.com/docs/editor/codebasics#_find-and-replace) 進行較大型的變更，或增加編輯器的多重游標限制設定。",
		"增加多重游標限制",
	],
	"vs/editor/browser/widget/diffEditor.contribution": [
		"可存取的 Diff 檢視器",
		"移至下一個差異",
		"開啟易存取差異檢視器",
		"移至上一個差異",
	],
	"vs/editor/browser/widget/diffEditorWidget": [
		"Diff 編輯器中用於插入的線條裝飾。",
		"Diff 編輯器中用於移除的線條裝飾。",
		" 使用 Shift + F7 瀏覽變更",
		"因其中一個檔案過大而無法比較。",
		"按一下以還原變更",
	],
	"vs/editor/browser/widget/diffEditorWidget2/accessibleDiffViewer": [
		"易存取差異檢視器中的 [插入] 圖示。",
		"易存取差異檢視器中的 [移除] 圖示。",
		"易存取差異檢視器中的 [關閉] 圖示。",
		"關閉",
		"可存取的 Diff 檢視器。使用向上和向下箭頭來瀏覽。",
		"未變更任一行",
		"已變更 1 行",
		"已變更 {0} 行",
		"{1} 項差異中的第 {0} 項: 原始行 {2}、{3}，修改行 {4}、{5}",
		"空白",
		"{0} 未變更行 {1}",
		"{0} 原始行 {1} 修改的行 {2}",
		"+ {0} 修改行 {1}",
		"- {0} 原始行 {1}",
	],
	"vs/editor/browser/widget/diffEditorWidget2/colors": [
		"在 Diff 編輯器中移動的文字的框線色彩。",
		"The active border color for text that got moved in the diff editor.",
	],
	"vs/editor/browser/widget/diffEditorWidget2/decorations": [
		"Diff 編輯器中用於插入的線條裝飾。",
		"Diff 編輯器中用於移除的線條裝飾。",
		"按一下以還原變更",
	],
	"vs/editor/browser/widget/diffEditorWidget2/diffEditorEditors": [
		" 使用 {0} 以開啟協助工具說明。",
	],
	"vs/editor/browser/widget/diffEditorWidget2/inlineDiffDeletedCodeMargin": [
		"複製刪除的行",
		"複製刪除的行",
		"複製變更的行",
		"複製變更的行",
		"複製刪除的行 ({0})",
		"複製變更的行 ({0})",
		"還原此變更",
	],
	"vs/editor/browser/widget/diffEditorWidget2/movedBlocksLines": [
		"Code moved with changes to line {0}-{1}",
		"Code moved with changes from line {0}-{1}",
		"Code moved to line {0}-{1}",
		"Code moved from line {0}-{1}",
	],
	"vs/editor/browser/widget/diffEditorWidget2/unchangedRanges": [
		"摺疊未變更的區域",
		"Click or drag to show more above",
		"Show all",
		"Click or drag to show more below",
		"{0} hidden lines",
		"Double click to unfold",
	],
	"vs/editor/browser/widget/diffReview": [
		"Diff 檢閱中 [插入] 的圖示。",
		"Diff 檢閱中 [移除] 的圖示。",
		"Diff 檢閱中 [關閉] 的圖示。",
		"關閉",
		"未變更任一行",
		"已變更 1 行",
		"已變更 {0} 行",
		"{1} 項差異中的第 {0} 項: 原始行 {2}、{3}，修改行 {4}、{5}",
		"空白",
		"{0} 未變更行 {1}",
		"{0} 原始行 {1} 修改的行 {2}",
		"+ {0} 修改行 {1}",
		"- {0} 原始行 {1}",
	],
	"vs/editor/browser/widget/inlineDiffMargin": [
		"複製已刪除的行",
		"複製已刪除的行",
		"複製變更的行",
		"複製變更的行",
		"複製已刪除的行 （{0}）",
		"複製變更的行 ({0})",
		"還原此變更",
		"複製已刪除的行 （{0}）",
		"複製變更的行 ({0})",
	],
	"vs/editor/common/config/editorConfigurationSchema": [
		"編輯器",
		"與 Tab 相等的空格數量。當 {0} 已開啟時，會根據檔案內容覆寫此設定。",
		"用於縮排或 \'tabSize\' 使用 `\"editor.tabSize\"` 值的空格數目。當 \'#editor.detectIndentation#\' 開啟時，會根據檔案內容覆寫這個設定。",
		"在按 `Tab` 時插入空格。當 {0} 開啟時，會根據檔案內容覆寫此設定。",
		"根據檔案內容，控制當檔案開啟時，是否自動偵測 {0} 和 {1}。",
		"移除尾端自動插入的空白字元。",
		"針對大型檔案停用部分高記憶體需求功能的特殊處理方式。",
		"控制是否應根據文件中的單字計算自動完成。",
		"僅建議來自使用中文件中的字組。",
		"建議來自所有已開啟文件中，語言相同的字組。",
		"建議來自所有已開啟文件中的字組。",
		"控制要從哪些文件計算以字組為基礎的完成作業。",
		"所有彩色主題皆已啟用語意醒目提示。",
		"所有彩色主題皆已停用語意醒目提示。",
		"語意醒目提示由目前之彩色佈景主題的 \'semanticHighlighting\' 設定所設定。",
		"控制 semanticHighlighting 是否會為支援的語言顯示。",
		"即使按兩下內容或按 `Escape`，仍保持瞄孔編輯器開啟。",
		"因效能的緣故，不會將超過此高度的行 Token 化",
		"控制權杖化是否應該在 Web 工作者上非同步進行。",
		"控制是否應該記錄非同步權杖化。僅適用偵錯。",
		"控制是否應使用舊版背景 Token 化來驗證非同步 Token 化。可能會減慢 Token 化的速度。僅用於偵錯。",
		"定義增加或減少縮排的括弧符號。",
		"左括弧字元或字串順序。",
		"右括弧字元或字串順序。",
		"定義當括弧配對著色已啟用時，由其巢狀層級著色的括弧配對。",
		"左括弧字元或字串順序。",
		"右括弧字元或字串順序。",
		"取消 Diff 計算前的逾時限制 (毫秒)。若無逾時，請使用 0。",
		"要計算差異的檔案大小上限 (MB)。使用 0 表示無限制。",
		"控制 Diff 編輯器要並排或內嵌顯示 Diff。",
		"If the diff editor width is smaller than this value, the inline view is used.",
		"If enabled and the editor width is too small, the inline view is used.",
		"啟用時，Diff 編輯器會在其字元邊緣顯示箭頭，以還原變更。",
		"啟用時，Diff 編輯器會忽略前置或後置空格的變更。",
		"控制 Diff 編輯器是否要為新增/移除的變更顯示 +/- 標記。",
		"控制編輯器是否顯示 codelens。",
		"一律不換行。",
		"依檢視區寬度換行。",
		"將依據 {0} 設定自動換行。",
		"使用舊版差異演算法。",
		"使用進階版差異演算法。",
		"Controls whether the diff editor shows unchanged regions. Only works when {0} is set.",
		"Controls how many lines are used for unchanged regions. Only works when {0} is set.",
		"Controls how many lines are used as a minimum for unchanged regions. Only works when {0} is set.",
		"Controls how many lines are used as context when comparing unchanged regions. Only works when {0} is set.",
		"控制差異編輯器是否應該顯示偵測到的程式碼移動。只有在設定了 {0} 時才有作用。",
		"控制 Diff 編輯器使用新的或舊的實作。",
		"控制差異編輯器是否顯示空白裝飾項目，以查看插入或刪除字元的位置。",
	],
	"vs/editor/common/config/editorOptions": [
		"使用平台 API 以偵測螢幕助讀程式附加",
		"使用螢幕助讀程式最佳化使用方式",
		"假設未附加螢幕助讀程式",
		"控制 UI 是否應於已為螢幕助讀程式最佳化的模式中執行。",
		"控制是否要在註解時插入空白字元。",
		"控制是否應以行註解的切換、新增或移除動作，忽略空白的行。",
		"控制複製時不選取任何項目是否會複製目前程式行。",
		"控制在輸入期間是否要跳過游標來尋找相符的項目。",
		"永不從編輯器選取範圍中植入搜尋字串。",
		"一律從編輯器選取範圍中植入搜尋字串，包括游標位置的字。",
		"只有來自編輯器選取範圍中的植入搜尋字串。",
		"控制 [尋找小工具] 中的搜尋字串是否來自編輯器選取項目。",
		"永不自動開啟 [在選取範圍中尋找] (預設)。",
		"一律自動開啟 [在選取範圍中尋找]。",
		"選取多行內容時，自動開啟 [在選取範圍中尋找]。",
		"控制自動開啟 [在選取範圍中尋找] 的條件。",
		"控制尋找小工具是否在 macOS 上讀取或修改共用尋找剪貼簿。",
		"控制尋找小工具是否應在編輯器頂端額外新增行。若為 true，當您可看到尋找小工具時，您的捲動範圍會超過第一行。",
		"當再也找不到其他相符項目時，控制是否自動從開頭 (或結尾) 重新開始搜尋。",
		"啟用/停用連字字型 (\'calt\' 和 \'liga\' 字型功能)。將此項變更為字串，以精確控制 \'font-feature-settings\' CSS 屬性。",
		"明確的 \'font-feature-settings\' CSS 屬性。如果只需要開啟/關閉連字，可以改為傳遞布林值。",
		"設定連字字型或字型功能。可以是布林值以啟用/停用連字，或代表 CSS \'font-feature-settings\' 屬性的字串。",
		"啟用/停用從 font-weight 到 font-variation-settings 的轉換。將此設定變更為字串，以更精細地控制 \'font-variation-settings\' CSS 屬性。",
		"明確的 \'font-variation-settings\' CSS 屬性。如果只需要將 font-weight 轉換為 font-variation-settings，可以改為傳遞布林值。",
		"設定字型變化。可以是布林值，以啟用/停用從 font-weight 到 font-variation-settings 的轉換，或是字串，做為 CSS \'font-variation-settings\' 屬性的值。",
		"控制字型大小 (像素)。",
		"只允許「一般」及「粗體」關鍵字，或介於 1 到 1000 之間的數值。",
		"控制字型粗細。接受「一般」及「粗體」關鍵字，或介於 1 到 1000 之間的數值。",
		"顯示結果的預覽檢視 (預設)",
		"移至主要結果並顯示預覽檢視",
		"前往主要結果，並對其他人啟用無預覽瀏覽",
		"此設定已淘汰，請改用 \'editor.editor.gotoLocation.multipleDefinitions\' 或 \'editor.editor.gotoLocation.multipleImplementations\' 等單獨設定。",
		"控制 \'Go to Definition\' 命令在有多個目標位置存在時的行為。",
		"控制 \'Go to Type Definition\' 命令在有多個目標位置存在時的行為。",
		"控制 \'Go to Declaration\' 命令在有多個目標位置存在時的行為。",
		"控制 \'Go to Implementations\' 命令在有多個目標位置存在時的行為。",
		"控制 \'Go to References\' 命令在有多個目標位置存在時的行為。",
		"當 \'Go to Definition\' 的結果為目前位置時，正在執行的替代命令識別碼。",
		"當 \'Go to Type Definition\' 的結果為目前位置時，正在執行的替代命令識別碼。",
		"當 \'Go to Declaration\' 的結果為目前位置時，正在執行的替代命令識別碼。",
		"當 \'Go to Implementation\' 的結果為目前位置時，正在執行的替代命令識別碼。",
		"當 \'Go to Reference\' 的結果為目前位置時，正在執行的替代命令識別碼。",
		"控制是否顯示暫留。",
		"控制暫留顯示的延遲時間 (以毫秒為單位)。",
		"控制當滑鼠移過時，是否應保持顯示暫留。",
		"如果有空間，則偏好在行上方顯示游標。",
		"假設所有字元的寬度均相同。這是一種快速的演算法，適用於等寬字型，以及字符寬度相同的部分指令碼 (例如拉丁文字元)。",
		"將外圍點計算委派給瀏覽器。這是緩慢的演算法，如果檔案較大可能會導致凍結，但在所有情況下都正常運作。",
		"控制計算外圍點的演算法。請注意，在協助工具模式中，會使用進階來獲得最佳體驗。",
		"在編輯器中啟用程式碼動作燈泡。",
		"在編輯器頂端捲動期間顯示巢狀的目前範圍。",
		"定義要顯示的自黏線數目上限。",
		"定義要用於判斷要黏住的線條的模型。如果大綱模型不存在，則會回到摺疊提供者模型，其會回到縮排模型。這三種情況中會遵守此順序。",
		"Enable scrolling of the sticky scroll widget with the editor\'s horizontal scrollbar.",
		"啟用編輯器中的內嵌提示。",
		"已啟用內嵌提示",
		"預設會顯示內嵌提示，並在按住 {0} 時隱藏",
		"預設會隱藏內嵌提示，並在按住 {0} 時顯示",
		"已停用內嵌提示",
		"控制編輯器中內嵌提示的字型大小。當設定的值小於 {1} 或大於編輯器字型大小時，則會使用{0} 預設值。",
		"控制編輯器中，內嵌提示的字型家族。設定為空白時，則會使用 {0}。",
		"在編輯器中啟用的內嵌提示周圍的填補。",
		"控制行高。\r\n - 使用 0 從字型大小自動計算行高。\r\n - 使用介於 0 和 8 之間的值作為字型大小的乘數。\r\n - 大於或等於 8 的值將用來作為有效值。",
		"控制是否會顯示縮圖",
		"控制是否會自動隱藏縮圖。",
		"縮圖大小與編輯器內容相同 (且可能會捲動)。",
		"縮圖會視需要伸縮，以填滿該編輯器的高度 (無捲動)。",
		"縮圖將視需要縮小，一律不會大於該編輯器 (無捲動)。",
		"控制縮圖的大小。",
		"控制要在哪端呈現縮圖。",
		"控制何時顯示迷你地圖滑桿。",
		"縮圖內所繪製的內容大小: 1、2 或 3。",
		"顯示行中的實際字元，而不是色彩區塊。",
		"限制縮圖的寬度，最多顯示某個數目的列。",
		"控制編輯器上邊緣與第一行之間的空格數。",
		"控制編輯器下邊緣與最後一行之間的空格數。",
		"啟用快顯，在您鍵入的同時顯示參數文件和類型資訊。",
		"控制提示功能表是否在清單結尾時循環或關閉。",
		"快速建議會顯示在建議小工具內",
		"快速建議會顯示為浮水印文字",
		"已停用快速建議",
		"允許在字串內顯示即時建議。",
		"允許在註解中顯示即時建議。",
		"允許在字串與註解以外之處顯示即時建議。",
		"控制輸入時是否應自動顯示建議。這可控制在註解、字串及其他程式碼中的輸入。可設定快速建議以隱形浮出文字或建議小工具顯示。另外也請注意 \'{0}\'-設定，其會控制建議是否由特殊字元所觸發。",
		"不顯示行號。",
		"行號以絕對值顯示。",
		"行號以目前游標的相對值顯示。",
		"每 10 行顯示行號。",
		"控制行號的顯示。",
		"這個編輯器尺規會轉譯的等寬字元數。",
		"此編輯器尺規的色彩。",
		"在某個數目的等寬字元之後顯示垂直尺規。如有多個尺規，就會使用多個值。若陣列空白，就不會繪製任何尺規。",
		"垂直捲軸只有在必要時才可見。",
		"垂直捲軸永遠可見。",
		"垂直捲軸永遠隱藏。",
		"控制項垂直捲軸的可見度。",
		"水平捲軸只有在必要時才可見。",
		"水平捲軸永遠可見。",
		"水平捲軸永遠隱藏。",
		"控制項水平捲軸的可見度。",
		"垂直捲軸的寬度。",
		"水平捲軸的高度。",
		"控制項按一下是否按頁面滾動或跳到按一下位置。",
		"控制是否醒目提示所有非基本的 ASCII 字元。只有介於 U+0020和 U+007E、tab、換行和歸位字元之間的字元會視為基本 ASCII。",
		"控制是否只保留空格或完全沒有寬度之字元的醒目提示。",
		"控制是否醒目提示與基本 ASCII 字元混淆的字元，但目前使用者地區設定中通用的字元除外。",
		"控制註解中的字元是否也應受到 Unicode 醒目提示。",
		"控制字串中的字元是否也應受到 Unicode 醒目提示。",
		"定義未醒目提示的允許字元。",
		"不會將允許地區設置中常見的 Unicode 字元強調顯示。",
		"控制是否要在編輯器中自動顯示內嵌建議。",
		"每當顯示內嵌建議時，顯示內嵌建議工具列。",
		"每當游標停留在內嵌建議上方時，顯示內嵌建議工具列。",
		"控制何時顯示內嵌建議工具列。",
		"控制內嵌建議如何與建議小工具互動。如果啟用，有可用的內嵌建議時，不會自動顯示建議小工具。",
		"控制是否啟用成對方括弧著色。使用 {0} 覆寫括弧亮顯顏色。",
		"控制每個括弧類型是否有自己的獨立色彩集區。",
		"啟用括弧配對輔助線。",
		"只啟用使用中括弧組的括弧配對輔助線。",
		"停用括弧配對輔助線。",
		"控制是否啟用成對方括弧指南。",
		"啟用水平輔助線作為垂直括弧配對輔助線的新增功能。",
		"只啟用使用中括弧配對的水平輔助線。",
		"停用水平括弧配對輔助線。",
		"控制是否啟用水平成對方括弧輔助線。",
		"控制編輯器是否應醒目提示使用中的成對括弧。",
		"控制編輯器是否應顯示縮排輔助線。",
		"醒目提示使用中的縮排輔助線。",
		"即使醒目提示括弧輔助線，仍醒目提示使用中的縮排輔助線。",
		"不要醒目提示使用中的縮排輔助線。",
		"控制編輯器是否應醒目提示使用中的縮排輔助線。",
		"插入建議而不覆寫游標旁的文字。",
		"插入建議並覆寫游標旁的文字。",
		"控制是否要在接受完成時覆寫字組。請注意，這取決於加入此功能的延伸模組。",
		"控制對於拚錯字是否進行篩選和排序其建議",
		"控制排序是否偏好游標附近的字組。",
		"控制記錄的建議選取項目是否在多個工作區和視窗間共用 (需要 `#editor.suggestSelection#`)。",
		"自動觸發 IntelliSense 時一律選取建議。",
		"自動觸發 IntelliSense 時永不選取建議。",
		"只有在從觸發字元觸發 IntelliSense 時，才選取建議。",
		"只有在您輸入時觸發 IntelliSense 時，才選取建議。",
		"控制小工具顯示時是否選取建議。請注意，這只適用於(\'#editor.quickSuggestions#\' 和 \'#editor.suggestOnTriggerCharacters#\') 自動觸發的建議，而且一律會在明確叫用時選取建議，例如透過 \'Ctrl+Space\'。",
		"控制正在使用的程式碼片段是否會避免快速建議。",
		"控制要在建議中顯示或隱藏圖示。",
		"控制建議小工具底下的狀態列可見度。",
		"控制是否要在編輯器中預覽建議結果。",
		"控制建議詳細資料是以內嵌於標籤的方式顯示，還是只在詳細資料小工具中顯示。",
		"此設定已淘汰。建議小工具現可調整大小。",
		"此設定已淘汰，請改用 \'editor.suggest.showKeywords\' 或 \'editor.suggest.showSnippets\' 等單獨設定。",
		"啟用時，IntelliSense 顯示「方法」建議。",
		"啟用時，IntelliSense 顯示「函式」建議。",
		"啟用時，IntelliSense 顯示「建構函式」建議。",
		"啟用時，IntelliSense 顯示「已取代」建議。",
		"啟用時，IntelliSense 篩選會要求第一個字元符合文字開頭，例如 `Console` 或 `WebCoNtext` 上的 `c`，但不是 `description` 上的 _not_。停用時，IntelliSense 會顯示更多結果，但仍會依相符品質排序結果。",
		"啟用時，IntelliSense 顯示「欄位」建議。",
		"啟用時，IntelliSense 顯示「變數」建議。",
		"啟用時，IntelliSense 顯示「類別」建議。",
		"啟用時，IntelliSense 顯示「結構」建議。",
		"啟用時，IntelliSense 顯示「介面」建議。",
		"啟用時，IntelliSense 顯示「模組」建議。",
		"啟用時，IntelliSense 顯示「屬性」建議。",
		"啟用時，IntelliSense 顯示「事件」建議。",
		"啟用時，IntelliSense 顯示「運算子」建議。",
		"啟用時，IntelliSense 顯示「單位」建議。",
		"啟用時，IntelliSense 顯示「值」建議。",
		"啟用時，IntelliSense 顯示「常數」建議。",
		"啟用時，IntelliSense 顯示「列舉」建議。",
		"啟用時，IntelliSense 顯示「enumMember」建議。",
		"啟用時，IntelliSense 顯示「關鍵字」建議。",
		"啟用時，IntelliSense 顯示「文字」建議。",
		"啟用時，IntelliSense 顯示「色彩」建議。",
		"啟用時，IntelliSense 顯示「檔案」建議。",
		"啟用時，IntelliSense 顯示「參考」建議。",
		"啟用時，IntelliSense 顯示「customcolor」建議。",
		"啟用時，IntelliSense 顯示「資料夾」建議。",
		"啟用時，IntelliSense 顯示「typeParameter」建議。",
		"啟用時，IntelliSense 顯示「程式碼片段」建議。",
		"啟用之後，IntelliSense 會顯示 `user`-suggestions。",
		"啟用時，IntelliSense 會顯示 `issues`-suggestions。",
		"是否應一律選取前置和後置的空白字元。",
		"是否應該選取子詞 (例如 \'fooBar\' 或 \'foo_bar\' 中的 \'foo\')。",
		"無縮排。換行從第 1 列開始。",
		"換行的縮排會與父行相同。",
		"換行的縮排為父行 +1。",
		"換行縮排為父行 +2。",
		"控制換行的縮排。",
		"控制您是否可以按住 `shift` 鍵 (而非在編輯器中開啟檔案)，將檔案拖放到文字編輯器中。",
		"控制將檔案放入編輯器時是否顯示小工具。此小工具可讓您控制檔案的置放方式。",
		"將檔案放入編輯器後顯示置放選取器小工具。",
		"永不顯示置放選取器小工具。改為一律使用預設置放提供者。",
		"控制是否可以以不同方式貼上內容。",
		"控制將內容貼上至編輯器時是否顯示小工具。此小工具可讓您控制檔案的貼上方式。",
		"將內容貼上編輯器後顯示貼上選取器小工具。",
		"永不顯示貼上選取器小工具。而是一律使用預設的貼上行為。",
		"控制是否透過提交字元接受建議。例如在 JavaScript 中，分號 (\';\') 可以是接受建議並鍵入該字元的提交字元。",
		"在建議進行文字變更時，僅透過 `Enter` 接受建議。",
		"控制除了 \'Tab\' 外，是否也透過 \'Enter\' 接受建議。這有助於避免混淆要插入新行或接受建議。",
		"控制編輯器中可一次由螢幕助讀程式讀出的行數。偵測到螢幕助讀程式時會自動預設為 500。警告: 若數字超過預設，可能會對效能有所影響。",
		"編輯器內容",
		"控制螢幕助讀程式是否宣告內嵌建議。",
		"使用語言配置確定何時自動關閉括號。",
		"僅當游標位於空白的左側時自動關閉括號。",
		"控制編輯器是否應在使用者新增左括弧後，自動加上右括弧。",
		"僅在自動插入相鄰的右引號或括弧時，才將其移除。",
		"控制編輯器是否應在刪除時移除相鄰的右引號或括弧。",
		"僅在自動插入右引號或括號時，才在其上方鍵入。",
		"控制編輯器是否應在右引號或括號上鍵入。",
		"使用語言配置確定何時自動關閉引號。",
		"僅當游標位於空白的左側時自動關閉引號。",
		"控制編輯器是否應在使用者新增開始引號後，自動加上關閉引號。",
		"編輯器不會自動插入縮排。",
		"編輯器會保留目前行的縮排。",
		"編輯器會保留目前行的縮排並接受語言定義的括號。",
		"編輯器會目前行的縮排、接受語言定義的括號並叫用語言定義的特殊 onEnterRules。",
		"編輯器會保留目前行的縮排、接受語言定義的括號並叫用語言定義的特殊 onEnterRules 並接受語言定義的 indentationRules。",
		"控制編輯器是否應在使用者鍵入、貼上、移動或縮排行時自動調整縮排。",
		"使用語言組態來決定何時自動環繞選取項目。",
		"用引號括住，而非使用括弧。",
		"用括弧括住，而非使用引號。 ",
		"控制編輯器是否應在鍵入引號或括弧時自動包圍選取範圍。",
		"當使用空格進行縮排時，會模擬定位字元的選取表現方式。選取範圍會依循定位停駐點。",
		"控制編輯器是否顯示 codelens。",
		"控制 CodeLens 的字型家族。",
		"控制 CodeLens 的字型大小 (像素)。設定為 0 時，會使用 90% 的 `#editor.fontSize#`。",
		"控制編輯器是否應轉譯內嵌色彩裝飾項目與色彩選擇器。",
		"讓色彩選擇器在按一下和停駐色彩在裝飾項目上時出現",
		"讓色彩選擇器在停駐色彩裝飾項目時出現",
		"讓色彩選擇器在按一下色彩裝飾項目時出現",
		"控制條件，讓色彩選擇器從色彩裝飾項目出現",
		"控制一次可在編輯器中呈現的色彩裝飾項目最大數目。",
		"啟用即可以滑鼠與按鍵選取進行資料行選取。",
		"控制語法醒目提示是否應複製到剪貼簿。",
		"控制資料指標動畫樣式。",
		"平滑插入號動畫已停用。",
		"只有當使用者使用明確手勢移動游標時，才會啟用平滑插入號動畫。",
		"永遠啟用平滑插入號動畫。",
		"控制是否應啟用平滑插入點動畫。 ",
		"控制資料指標樣式。",
		"控制游標上下周圍可顯示的前置線 (最小為 0) 和後置線 (最小為 1) 的最小數目。在某些編輯器中稱為 \'scrollOff\' 或 \'scrollOffset\'。",
		"只有通過鍵盤或 API 觸發時，才會施行 `cursorSurroundingLines`。",
		"一律強制執行 `cursorSurroundingLines`",
		"控制應施行 `cursorSurroundingLines` 的時機。",
		"控制游標寬度，當 `#editor.cursorStyle#` 設定為 `line` 時。",
		"控制編輯器是否允許透過拖放來移動選取項目。",
		"使用新的 svg 轉譯方法。",
		"使用具有字型字元的新轉譯方法。",
		"使用穩定轉譯方法。",
		"控制是否使用新的實驗性方法來呈現空白字元。",
		"按下 `Alt` 時的捲動速度乘數。",
		"控制編輯器是否啟用程式碼摺疊功能。",
		"使用語言特定摺疊策略 (如果可用)，否則使用縮排式策略。",
		"使用縮排式摺疊策略。",
		"控制計算資料夾範圍的策略。",
		"控制編輯器是否應將折疊的範圍醒目提示。",
		"控制編輯器是否會自動摺疊匯入範圍。",
		"可摺疊區域的數目上限。增加此值可能會造成當目前的來源有大量可摺疊區域時，編輯器的回應速度變慢。",
		"控制按一下已折疊行後方的空白內容是否會展開行。",
		"控制字型家族。",
		"控制編輯器是否應自動為貼上的內容設定格式。必須有可用的格式器，而且格式器應能夠為文件中的一個範圍設定格式。",
		"控制編輯器是否應自動在鍵入後設定行的格式。",
		"控制編輯器是否應轉譯垂直字符邊界。字符邊界最常用來進行偵錯。",
		"控制游標是否應隱藏在概觀尺規中。",
		"控制字母間距 (像素)。",
		"控制編輯器是否已啟用連結編輯。相關符號 (例如 HTML 標籤) 會根據語言在編輯時更新。",
		"控制編輯器是否應偵測連結並使其可供點選。",
		"將符合的括號醒目提示。",
		"要用於滑鼠滾輪捲動事件 `deltaX` 和 `deltaY` 的乘數。",
		"使用滑鼠滾輪並按住 `Ctrl` 時，縮放編輯器的字型",
		"在多個游標重疊時將其合併。",
		"對應Windows和Linux的\'Control\'與對應 macOS 的\'Command\'。",
		"對應Windows和Linux的\'Alt\'與對應macOS的\'Option\'。",
		"用於在滑鼠新增多個游標的修飾元。[移至定義] 和 [開啟連結] 滑鼠手勢會加以適應，以避免與 [多個游標的修飾元](https://code.visualstudio.com/docs/editor/codebasics#_multicursor-modifier) 相衝突。",
		"每個游標都會貼上一行文字。",
		"每個游標都會貼上全文。",
		"當已貼上文字的行數與游標數相符時控制貼上功能。",
		"控制一次可在作用中編輯器中的游標數目上限。",
		"控制編輯器是否應醒目顯示出現的語意符號。",
		"控制是否應在概觀尺規周圍繪製框線。",
		"開啟預覽時焦點樹狀",
		"開啟時聚焦編輯器",
		"控制要聚焦內嵌編輯器或預覽小工具中的樹系。",
		"控制「前往定義」滑鼠手勢，是否一律開啟瞄核小工具。",
		"控制在快速建議顯示後的延遲 (以毫秒為單位)。",
		"控制編輯器是否會自動依類型重新命名。",
		"已淘汰，請改用 `editor.linkedEditing`。",
		"控制編輯器是否應顯示控制字元。",
		"在檔案結尾為新行時，呈現最後一行的號碼。",
		"醒目提示裝訂邊和目前的行。",
		"控制編輯器如何顯示目前行的醒目提示。",
		"控制當聚焦於編輯器時，編輯器是否應僅轉譯目前行的醒目提示。",
		"轉譯空白字元，但文字之間的單一空格除外。",
		"只轉譯所選文字的空白字元。",
		"只轉譯結尾空白字元。",
		"控制編輯器應如何轉譯空白字元。",
		"控制選取範圍是否有圓角",
		"控制編輯器水平捲動的額外字元數。",
		"控制編輯器是否捲動到最後一行之外。",
		"同時進行垂直與水平捲動時，僅沿主軸捲動。避免在軌跡板上進行垂直捲動時發生水平漂移。",
		"控制是否支援 Linux 主要剪貼簿。",
		"控制編輯器是否應醒目提示與選取項目類似的相符項目。",
		"一律顯示摺疊控制項。",
		"永不顯示摺疊控制項與減少裝訂邊大小。",
		"僅當滑鼠懸停在活動列上時，才顯示折疊功能。",
		"控制摺疊控制項在裝訂邊上的顯示時機。",
		"控制未使用程式碼的淡出。",
		"控制已刪除的淘汰變數。",
		"將程式碼片段建議顯示於其他建議的頂端。",
		"將程式碼片段建議顯示於其他建議的下方。",
		"將程式碼片段建議與其他建議一同顯示。",
		"不顯示程式碼片段建議。",
		"控制程式碼片段是否隨其他建議顯示，以及其排序方式。",
		"控制編輯器是否會使用動畫捲動",
		"Controls whether the accessibility hint should be provided to screen reader users when an inline completion is shown.",
		"建議小工具的字型大小。當設定為 {0} 時，則會使用 {1} 的值。",
		"建議小工具的行高。當設定為 {0} 時，則會使用 {1} 的值。最小值為 8。",
		"控制建議是否應在鍵入觸發字元時自動顯示。",
		"一律選取第一個建議。",
		"除非進一步鍵入選取了建議，否則選取最近的建議，例如 `console.| -> console.log`，原因是最近完成了 `log`。",
		"根據先前已完成該建議的前置詞選取建議，例如 `co -> console` 和 `con -> const`。",
		"控制在顯示建議清單時如何預先選取建議。",
		"按 Tab 時，Tab 完成會插入最符合的建議。",
		"停用 tab 鍵自動完成。",
		"在程式碼片段的首碼相符時使用 Tab 完成。未啟用 \'quickSuggestions\' 時效果最佳。",
		"啟用 tab 鍵自動完成。",
		"自動移除異常的行結束字元。",
		"忽略異常的行結束字元。",
		"要移除之異常的行結束字元提示。",
		"移除可能導致問題的異常行結束字元。",
		"插入和刪除接在定位停駐點後的空白字元。",
		"使用預設的分行符號規則。",
		"中文/日文/韓文 (CJK) 文字不應該使用斷字。非中日韓的文字行為與一般文字相同。",
		"控制用於中文/日文/韓文 (CJK) 文字的斷字規則。",
		"在執行文字相關導覽或作業時要用作文字分隔符號的字元",
		"一律不換行。",
		"依檢視區寬度換行。",
		"於 \'#editor.wordWrapColumn#\' 換行。",
		"當檢視區縮至最小並設定 \'#editor.wordWrapColumn#\' 時換行。",
		"控制如何換行。",
		"當 `#editor.wordWrap#` 為 `wordWrapColumn` 或 `bounded` 時，控制編輯器中的資料行換行。",
		"控制是否應使用預設的文件色彩提供者顯示內嵌色彩裝飾",
		"控制編輯器是否接收索引標籤，或將其延遲至工作台進行流覽。",
	],
	"vs/editor/common/core/editorColorRegistry": [
		"目前游標位置行的反白顯示背景色彩。",
		"目前游標位置行之周圍框線的背景色彩。",
		"醒目提示範圍的背景色彩，例如快速開啟並尋找功能。其不得為不透明色彩，以免隱藏底層裝飾。",
		"反白顯示範圍周圍邊框的背景顏色。",
		"醒目提示符號的背景色彩，相似於前往下一個定義或前往下一個/上一個符號。色彩必須透明，以免隱藏底層裝飾。",
		"醒目提示周圍的邊界背景色彩。",
		"編輯器游標的色彩。",
		"編輯器游標的背景色彩。允許自訂區塊游標重疊的字元色彩。",
		"編輯器中空白字元的色彩。",
		"編輯器行號的色彩。",
		"編輯器縮排輔助線的色彩。",
		"\'editorIndentGuide.background\' 已被取代。請改用 \'editorIndentGuide.background1\'。",
		"使用中編輯器縮排輔助線的色彩。",
		"\'editorIndentGuide.activeBackground\' 已被取代。請改用 \'editorIndentGuide.activeBackground1\'。",
		"編輯器縮排輔助線的色彩 (1)。",
		"編輯器縮排輔助線的色彩 (2)。",
		"編輯器縮排輔助線的色彩 (3)。",
		"編輯器縮排輔助線的色彩 (4)。",
		"編輯器縮排輔助線的色彩 (5)。",
		"編輯器縮排輔助線的色彩 (6)。",
		"使用中編輯器縮排輔助線的色彩 (1)。",
		"使用中編輯器縮排輔助線的色彩 (2)。",
		"使用中編輯器縮排輔助線的色彩 (3)。",
		"使用中編輯器縮排輔助線的色彩 (4)。",
		"使用中編輯器縮排輔助線的色彩 (5)。",
		"使用中編輯器縮排輔助線的色彩 (6)。",
		"編輯器使用中行號的色彩",
		"Id 已取代。請改用 \'editorLineNumber.activeForeground\' 。",
		"編輯器使用中行號的色彩",
		"editor.renderFinalNewline 設定為暗灰色時，最終編輯器線條的色彩。",
		"編輯器尺規的色彩",
		"編輯器程式碼濾鏡的前景色彩",
		"成對括號背景色彩",
		"成對括號邊框色彩",
		"預覽檢視編輯器尺規的邊框色彩.",
		"編輯器概觀尺規的背景色彩。",
		"編輯器邊框的背景顏色,包含行號與字形圖示的邊框.",
		"編輯器中不必要 (未使用) 原始程式碼的框線色彩。",
		"編輯器中不必要 (未使用) 原始程式碼的不透明度。例如 \"#000000c0” 會以 75% 的不透明度轉譯程式碼。針對高對比主題，使用 \'editorUnnecessaryCode.border\' 主題色彩可為不必要的程式碼加上底線，而不是將其變淡。",
		"編輯器中浮水印文字的邊框色彩。",
		"編輯器中浮水印文字的前景色彩。",
		"編輯器中浮水印文字的背景色彩。",
		"範圍醒目提示的概觀尺規標記色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"錯誤的概觀尺規標記色彩。",
		"警示的概觀尺規標記色彩。",
		"資訊的概觀尺規標記色彩。",
		"括弧 (1) 的前景色彩。需要啟用成對方括弧著色。",
		"括弧 (2) 的前景色彩。需要啟用成對方括弧著色。",
		"括弧 (3) 的前景色彩。需要啟用成對方括弧著色。",
		"括弧 (4) 的前景色彩。需要啟用成對方括弧著色。",
		"括弧 (5) 的前景色彩。需要啟用成對方括弧著色。",
		"括弧 (6) 的前景色彩。需要啟用成對方括弧著色。",
		"未預期括弧的前景色彩。",
		"非使用中括弧配對輔助線 (1) 的背景色彩。需要啟用括弧配對輔助線。",
		"非使用中括弧配對輔助線 (2) 的背景色彩。需要啟用括弧配對輔助線。",
		"非使用中括弧配對輔助線 (3) 的背景色彩。需要啟用括弧配對輔助線。",
		"非使用中括弧配對輔助線 (4) 的背景色彩。需要啟用括弧配對輔助線。",
		"非使用中括弧配對輔助線 (5) 的背景色彩。需要啟用括弧配對輔助線。",
		"非使用中括弧配對輔助線 (6) 的背景色彩。需要啟用括弧配對輔助線。",
		"使用中括弧配對輔助線 (1) 的背景色彩。需要啟用括弧配對輔助線。",
		"使用中括弧配對輔助線 (2) 的背景色彩。需要啟用括弧配對輔助線。",
		"使用中括弧配對輔助線 (3) 的背景色彩。需要啟用括弧配對輔助線。",
		"使用中括弧配對輔助線 (4) 的背景色彩。需要啟用括弧配對輔助線。",
		"使用中括弧配對輔助線 (5) 的背景色彩。需要啟用括弧配對輔助線。",
		"使用中括弧配對輔助線 (6) 的背景色彩。需要啟用括弧配對輔助線。",
		"用來醒目提示 Unicode 字元的框線色彩。",
		"用來醒目提示 Unicode 字元的背景色彩。",
	],
	"vs/editor/common/editorContextKeys": [
		"編輯器文字是否有焦點 (游標閃爍)",
		"編輯器或編輯器小工具是否有焦點 (例如焦點位於 [尋找] 小工具中)",
		"編輯器或 RTF 輸入是否有焦點 (游標閃爍)",
		"編輯器是否為唯讀",
		"內容是否為 Diff 編輯器",
		"內容是否為內嵌 Diff 編輯器",
		"Whether a moved code block is selected for comparison",
		"是否顯示易存取差異檢視器",
		"Whether the diff editor render side by side inline breakpoint is reached",
		"\'editor.columnSelection\' 是否已啟用",
		"編輯器是否有選取文字",
		"編輯器是否有多個選取項目",
		"\'Tab\' 是否會將焦點移出編輯器",
		"編輯器暫留是否顯示",
		"編輯器暫留是否聚焦",
		"自黏捲動是否聚焦",
		"自黏捲動是否顯示",
		"是否顯示獨立的顏色選擇器",
		"獨立的顏色選擇器是否聚焦",
		"編輯器是否為較大編輯器的一部分 (例如筆記本)",
		"編輯器的語言識別碼",
		"編輯器是否有完成項目提供者",
		"編輯器是否有程式碼動作提供者",
		"編輯器是否有 CodeLens 提供者",
		"編輯器是否有定義提供者",
		"編輯器是否有宣告提供者",
		"編輯器是否有實作提供者",
		"編輯器是否有型別定義提供者",
		"編輯器是否有暫留提供者",
		"編輯器是否有文件醒目提示提供者",
		"編輯器是否有文件符號提供者",
		"編輯器是否有參考提供者",
		"編輯器是否有重新命名提供者",
		"編輯器是否有簽章說明提供者",
		"編輯器是否有內嵌提示提供者",
		"編輯器是否有文件格式化提供者",
		"編輯器是否有文件選取項目格式化提供者",
		"編輯器是否有多個文件格式化提供者",
		"編輯器是否有多個文件選取項目格式化提供者",
	],
	"vs/editor/common/languages": [
		"陣列",
		"布林值",
		"類別",
		"常數",
		"建構函式",
		"列舉",
		"列舉成員",
		"事件",
		"欄位",
		"檔案",
		"函式",
		"介面",
		"索引鍵",
		"方法",
		"模組",
		"命名空間",
		"null",
		"數字",
		"物件",
		"運算子",
		"套件",
		"屬性",
		"字串",
		"結構",
		"型別參數",
		"變數",
		"{0} ({1})",
	],
	"vs/editor/common/languages/modesRegistry": [
		"純文字",
	],
	"vs/editor/common/model/editStack": [
		"正在鍵入",
	],
	"vs/editor/common/standaloneStrings": [
		"開發人員: 檢查權杖",
		"前往行/欄...",
		"顯示所有快速存取提供者",
		"命令選擇區",
		"顯示並執行命令",
		"移至符號...",
		"前往符號 (依類別)...",
		"編輯器內容",
		"按 Alt+F1 可取得協助工具選項。",
		"切換高對比佈景主題",
		"已在 {1} 檔案中進行 {0} 項編輯",
	],
	"vs/editor/common/viewLayout/viewLineRenderer": [
		"顯示更多 ({0})",
		"{0} chars",
	],
	"vs/editor/contrib/anchorSelect/browser/anchorSelect": [
		"選取範圍錨點",
		"設定錨點為 {0}:{1}",
		"設定選取範圍錨點",
		"前往選取範圍錨點",
		"選取從錨點到游標之間的範圍",
		"取消選取範圍錨點",
	],
	"vs/editor/contrib/bracketMatching/browser/bracketMatching": [
		"成對括弧的概觀尺規標記色彩。",
		"移至方括弧",
		"選取至括弧",
		"移除括弧",
		"前往括弧(&&B)",
	],
	"vs/editor/contrib/caretOperations/browser/caretOperations": [
		"將所選文字向左移動",
		"將所選文字向右移動",
	],
	"vs/editor/contrib/caretOperations/browser/transpose": [
		"調換字母",
	],
	"vs/editor/contrib/clipboard/browser/clipboard": [
		"剪下(&&T)",
		"剪下",
		"剪下",
		"剪下",
		"複製(&&C)",
		"複製",
		"複製",
		"複製",
		"複製為",
		"複製為",
		"共用",
		"共用",
		"共用",
		"貼上(&&P)",
		"貼上",
		"貼上",
		"貼上",
		"隨語法醒目提示複製",
	],
	"vs/editor/contrib/codeAction/browser/codeAction": [
		"套用程式碼動作時發生未知的錯誤",
	],
	"vs/editor/contrib/codeAction/browser/codeActionCommands": [
		"要執行程式碼動作的種類。",
		"控制要套用傳回動作的時機。",
		"一律套用第一個傳回的程式碼動作。",
		"如果傳回的程式碼動作是唯一動作，則加以套用。",
		"不要套用傳回的程式碼動作。",
		"控制是否僅應傳回偏好的程式碼動作。",
		"快速修復...",
		"沒有可用的程式碼操作",
		"沒有 \"{0}\" 的偏好程式碼動作",
		"沒有 \"{0}\" 可用的程式碼動作",
		"沒有可用的偏好程式碼動作",
		"沒有可用的程式碼操作",
		"重構...",
		"沒有適用於 \'{0}\' 的偏好重構。",
		"沒有可用的 \"{0}\" 重構",
		"沒有可用的偏好重構",
		"沒有可用的重構",
		"來源動作...",
		"沒有適用於 \'{0}\' 的偏好來源動作",
		"沒有 \"{0}\" 可用的來源動作",
		"沒有可用的偏好來源動作",
		"沒有可用的來源動作",
		"組織匯入",
		"沒有任何可用的組織匯入動作",
		"全部修正",
		"沒有全部修正動作可用",
		"自動修正...",
		"沒有可用的自動修正",
	],
	"vs/editor/contrib/codeAction/browser/codeActionContributions": [
		"啟用/停用在 [程式碼動作] 功能表中顯示群組標頭。",
	],
	"vs/editor/contrib/codeAction/browser/codeActionController": [
		"隱藏已停用項目",
		"顯示已停用項目",
	],
	"vs/editor/contrib/codeAction/browser/codeActionMenu": [
		"更多動作...",
		"快速修正...",
		"擷取...",
		"內嵌...",
		"重寫...",
		"移動...",
		"範圍陳述式...",
		"來源動作...",
	],
	"vs/editor/contrib/codeAction/browser/lightBulbWidget": [
		"顯示程式碼動作。偏好的快速修正可用 ({0})",
		"顯示程式碼動作 ({0})",
		"顯示程式碼動作",
	],
	"vs/editor/contrib/codelens/browser/codelensController": [
		"顯示目前行的 Code Lens 命令",
	],
	"vs/editor/contrib/colorPicker/browser/colorPickerWidget": [
		"按一下以切換色彩選項 (rgb/hsl/hex)",
		"要關閉顏色選擇器的圖示",
	],
	"vs/editor/contrib/colorPicker/browser/standaloneColorPickerActions": [
		"顯示或聚焦獨立的顏色選擇器",
		"&&顯示或聚焦獨立的顏色選擇器",
		"隱藏顏色選擇器",
		"使用獨立的顏色選擇器插入顏色",
	],
	"vs/editor/contrib/comment/browser/comment": [
		"切換行註解",
		"切換行註解(&&T)",
		"加入行註解",
		"移除行註解",
		"切換區塊註解",
		"切換區塊註解(&&B)",
	],
	"vs/editor/contrib/contextmenu/browser/contextmenu": [
		"縮圖",
		"轉譯字元",
		"垂直大小",
		"按比例",
		"填滿",
		"最適大小",
		"滑桿",
		"滑鼠移至上方",
		"一律",
		"顯示編輯器內容功能表",
	],
	"vs/editor/contrib/cursorUndo/browser/cursorUndo": [
		"游標復原",
		"游標重做",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/copyPasteContribution": [
		"貼上為...",
		"要嘗試套用的貼上編輯的識別碼。如果未提供，編輯器將顯示選擇器。",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/copyPasteController": [
		"是否顯示貼上小工具",
		"顯示貼上選項...",
		"正在執行貼上處理常式。按一下以取消",
		"選取貼上動作",
		"執行貼上處理常式",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/defaultProviders": [
		"內建",
		"插入純文字",
		"插入 URI",
		"插入 URI",
		"插入路徑",
		"插入路徑",
		"插入相對路徑",
		"插入相對路徑",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/dropIntoEditorContribution": [
		"Configures the default drop provider to use for content of a given mime type.",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/dropIntoEditorController": [
		"是否顯示卸除小工具",
		"顯示卸除選項...",
		"正在執行置放處理常式。按一下以取消",
	],
	"vs/editor/contrib/editorState/browser/keybindingCancellation": [
		"編輯器是否執行可取消的作業，例如「預覽參考」",
	],
	"vs/editor/contrib/find/browser/findController": [
		"尋找",
		"尋找(&&F)",
		"覆寫 \"Use Regular Expression\" 旗標。\r\n日後將不會儲存此旗標。\r\n0: 不執行任何動作\r\n1: True\r\n2: False",
		"覆寫 \"Match Whole Word\" 旗標。\r\n日後將不會儲存此旗標。\r\n0: 不執行任何動作\r\n1: True\r\n2: False",
		"覆寫 \"Math Case\" 旗標。\r\n日後將不會儲存此旗標。\r\n0: 不執行任何動作\r\n1: True\r\n2: False",
		"覆寫 \"Preserve Case\" 旗標。\r\n日後將不會儲存此旗標。\r\n0: 不執行任何動作\r\n1: True\r\n2: False",
		"使用引數尋找",
		"尋找選取項目",
		"尋找下一個",
		"尋找上一個",
		"移至相符項目...",
		"沒有相符項目。嘗試搜尋其他項目。",
		"輸入數字以前往特定相符項目 (介於 1 到 {0})",
		"請輸入介於 1 和 {0} 之間的數字。",
		"請輸入介於 1 和 {0} 之間的數字。",
		"尋找下一個選取項目",
		"尋找上一個選取項目",
		"取代",
		"取代(&&R)",
	],
	"vs/editor/contrib/find/browser/findWidget": [
		"編輯器尋找小工具中 [在選取範圍中尋找] 的圖示。",
		"表示編輯器尋找小工具已摺疊的圖示。",
		"表示編輯器尋找小工具已展開的圖示。",
		"編輯器尋找小工具中 [取代] 的圖示。",
		"編輯器尋找小工具中 [全部取代] 的圖示。",
		"編輯器尋找小工具中 [尋找上一個] 的圖示。",
		"編輯器尋找小工具中 [尋找下一個] 的圖示。",
		"尋找/取代",
		"尋找",
		"尋找",
		"上一個相符項目",
		"下一個相符項目",
		"在選取範圍中尋找",
		"關閉",
		"取代",
		"取代",
		"取代",
		"全部取代",
		"切換取代",
		"僅反白顯示前 {0} 筆結果，但所有尋找作業會在完整文字上執行。",
		"{1} 的 {0}",
		"查無結果",
		"找到 {0}",
		"以 \'{1}\' 找到 {0}",
		"以 \'{1}\' 找到 {0}，位於 {2}",
		"已以 \'{1}\' 找到 {0}",
		"Ctrl+Enter 現在會插入分行符號，而不會全部取代。您可以修改 editor.action.replaceAll 的按鍵繫結關係，以覆寫此行為。",
	],
	"vs/editor/contrib/folding/browser/folding": [
		"展開",
		"以遞迴方式展開",
		"摺疊",
		"切換摺疊",
		"以遞迴方式摺疊",
		"摺疊全部區塊註解",
		"摺疊所有區域",
		"展開所有區域",
		"折疊所選區域以外的所有區域",
		"展開所選區域以外的所有區域",
		"全部摺疊",
		"全部展開",
		"移至父代摺疊",
		"移至上一個摺疊範圍",
		"移至下一個摺疊範圍",
		"從選取範圍建立摺疊範圍",
		"移除手動折疊範圍",
		"摺疊層級 {0}",
	],
	"vs/editor/contrib/folding/browser/foldingDecorations": [
		"已摺疊範圍後的背景色彩。色彩不得處於不透明狀態，以免隱藏底層裝飾。",
		"編輯器裝訂邊的摺疊控制項色彩。",
		"編輯器字符邊界中 [展開的範圍] 的圖示。",
		"編輯器字符邊界中 [摺疊的範圍] 的圖示。",
		"編輯器字符邊界中手動摺疊範圍的圖示。",
		"編輯器字符邊界中手動展開範圍的圖示。",
	],
	"vs/editor/contrib/fontZoom/browser/fontZoom": [
		"編輯器字體放大",
		"編輯器字型縮小",
		"編輯器字體重設縮放",
	],
	"vs/editor/contrib/format/browser/format": [
		"在行 {0} 編輯了 1 項格式",
		"在行 {1} 編輯了 {0} 項格式",
		"在行 {0} 與行 {1} 之間編輯了 1 項格式",
		"在行 {1} 與行 {2} 之間編輯了 {0} 項格式",
	],
	"vs/editor/contrib/format/browser/formatActions": [
		"格式化文件",
		"格式化選取範圍",
	],
	"vs/editor/contrib/gotoError/browser/gotoError": [
		"移至下一個問題 (錯誤, 警告, 資訊)",
		"[前往下一個標記] 的圖示。",
		"移至上一個問題 (錯誤, 警告, 資訊)",
		"[前往上一個標記] 的圖示。",
		"移至檔案裡面的下一個問題 (錯誤, 警告, 資訊)",
		"下一個問題(&&P)",
		"移至檔案裡面的上一個問題 (錯誤, 警告, 資訊)",
		"前一個問題(&&P)",
	],
	"vs/editor/contrib/gotoError/browser/gotoErrorWidget": [
		"錯誤",
		"警告",
		"資訊",
		"提示",
		"{0} 於 {1}。",
		"{0} 個問題 (共 {1} 個)",
		"{0} 個問題 (共 {1} 個)",
		"編輯器標記導覽小工具錯誤的色彩。",
		"編輯器標記導覽小工具錯誤標題背景。",
		"編輯器標記導覽小工具警告的色彩。",
		"編輯器標記導覽小工具警告標題背景。",
		"編輯器標記導覽小工具資訊的色彩",
		"編輯器標記導覽小工具資訊標題背景。",
		"編輯器標記導覽小工具的背景。",
	],
	"vs/editor/contrib/gotoSymbol/browser/goToCommands": [
		"查看",
		"定義",
		"找不到 \'{0}\' 的定義",
		"找不到任何定義",
		"移至定義",
		"移至定義(&&D)",
		"在一側開啟定義",
		"瞄核定義",
		"宣告",
		"找不到 \'{0}\' 的宣告 ",
		"找不到任何宣告",
		"移至宣告",
		"前往宣告(&&D)",
		"找不到 \'{0}\' 的宣告 ",
		"找不到任何宣告",
		"預覽宣告",
		"類型定義",
		"找不到 \'{0}\' 的任何類型定義",
		"找不到任何類型定義",
		"移至類型定義",
		"前往類型定義(&&T)",
		"預覽類型定義",
		"實作",
		"找不到 \'{0}\' 的任何實作",
		"找不到任何實作",
		"前往實作",
		"前往實作(&&I)",
		"查看實作",
		"未找到 \"{0}\" 的參考",
		"未找到參考",
		"前往參考",
		"前往參考(&&R)",
		"參考",
		"預覽參考",
		"參考",
		"前往任何符號",
		"位置",
		"\'{0}\' 沒有結果",
		"參考",
	],
	"vs/editor/contrib/gotoSymbol/browser/link/goToDefinitionAtPosition": [
		"按一下以顯示 {0} 項定義。",
	],
	"vs/editor/contrib/gotoSymbol/browser/peek/referencesController": [
		"是否顯示參考瞄核，例如「瞄核參考」或「瞄核定義」",
		"正在載入...",
		"{0} ({1})",
	],
	"vs/editor/contrib/gotoSymbol/browser/peek/referencesTree": [
		"{0} 個參考",
		"{0} 個參考",
		"參考",
	],
	"vs/editor/contrib/gotoSymbol/browser/peek/referencesWidget": [
		"無法預覽",
		"查無結果",
		"參考",
	],
	"vs/editor/contrib/gotoSymbol/browser/referencesModel": [
		"在資料行 {2} 行 {1} 的 {0} 中",
		"在資料行 {3} 行 {2} 的 {1} 的 {0} 中",
		"1 個符號位於 {0}, 完整路徑 {1}",
		"{0} 個符號位於 {1}, 完整路徑 {2}",
		"找不到結果",
		"在 {0} 中找到 1 個符號",
		"在 {1} 中找到 {0} 個符號",
		"在 {1} 個檔案中找到 {0} 個符號",
	],
	"vs/editor/contrib/gotoSymbol/browser/symbolNavigation": [
		"是否有只能透過鍵盤瀏覽的符號位置。",
		"{1} 的符號 {0}，{2} 為下一個",
		"{1} 的符號 {0}",
	],
	"vs/editor/contrib/hover/browser/hover": [
		"顯示或聚焦暫留",
		"顯示定義預覽懸停",
		"向上捲動暫留",
		"向下捲動暫留",
		"向左捲動暫留",
		"向右捲動暫留",
		"上一頁暫留",
		"下一頁暫留",
		"移至上方暫留",
		"移至下方暫留",
	],
	"vs/editor/contrib/hover/browser/markdownHoverParticipant": [
		"正在載入...",
		"由於效能原因，已暫停轉譯。這可透過 `editor.stopRenderingLineAfter` 進行設定。",
		"因效能的緣故，已跳過將長的行 Token 化。您可透過 `editor.maxTokenizationLineLength` 設定。",
	],
	"vs/editor/contrib/hover/browser/markerHoverParticipant": [
		"檢視問題",
		"沒有可用的快速修正",
		"正在檢查快速修正...",
		"沒有可用的快速修正",
		"快速修復...",
	],
	"vs/editor/contrib/inPlaceReplace/browser/inPlaceReplace": [
		"以上一個值取代",
		"以下一個值取代",
	],
	"vs/editor/contrib/indentation/browser/indentation": [
		"將縮排轉換成空格",
		"將縮排轉換成定位點",
		"已設定的定位點大小",
		"預設索引標籤大小",
		"目前的索引標籤大小",
		"選取目前檔案的定位點大小",
		"使用 Tab 進行縮排",
		"使用空格鍵進行縮排",
		"變更索引標籤顯示大小",
		"偵測內容中的縮排",
		"重新將行縮排",
		"重新將選取的行縮排",
	],
	"vs/editor/contrib/inlayHints/browser/inlayHintsHover": [
		"按兩下以插入",
		"cmd + 按一下",
		"ctrl + 按一下",
		"選項 + 按一下",
		"alt + 按一下",
		"前往 [定義] ({0})，按一下滑鼠右鍵以了解更多",
		"移至定義 ({0})",
		"執行命令",
	],
	"vs/editor/contrib/inlineCompletions/browser/commands": [
		"顯示下一個內嵌建議",
		"顯示上一個內嵌建議",
		"觸發內嵌建議",
		"接受下一個內嵌建議字組",
		"接受字組",
		"接受下一個內嵌建議行",
		"接受行",
		"接受內嵌建議",
		"接受",
		"隱藏內嵌建議",
		"永遠顯示工具列",
	],
	"vs/editor/contrib/inlineCompletions/browser/hoverParticipant": [
		"建議:",
	],
	"vs/editor/contrib/inlineCompletions/browser/inlineCompletionContextKeys": [
		"是否顯示內嵌建議",
		"內嵌建議是否以空白字元開頭",
		"內嵌建議的開頭是否為空白，且比 Tab 能插入的字元要小",
		"是否應隱藏目前建議的其他建議",
	],
	"vs/editor/contrib/inlineCompletions/browser/inlineCompletionsController": [
		"Inspect this in the accessible view ({0})",
	],
	"vs/editor/contrib/inlineCompletions/browser/inlineCompletionsHintsWidget": [
		"[顯示下一個參數提示] 的圖示。",
		"[顯示上一個參數提示] 的圖示。",
		"{0} ({1})",
		"上一步",
		"下一步",
	],
	"vs/editor/contrib/lineSelection/browser/lineSelection": [
		"展開線條選取範圍",
	],
	"vs/editor/contrib/linesOperations/browser/linesOperations": [
		"將行向上複製",
		"將行向上複製(&&C)",
		"將行向下複製",
		"將行向下複製(&&P)",
		"重複選取項目",
		"重複選取項目(&&D)",
		"上移一行",
		"上移一行(&&V)",
		"下移一行",
		"下移一行(&&L)",
		"遞增排序行",
		"遞減排序行",
		"刪除重複的行",
		"修剪尾端空白",
		"刪除行",
		"縮排行",
		"凸排行",
		"在上方插入行",
		"在下方插入行",
		"左邊全部刪除",
		"刪除所有右方項目",
		"連接線",
		"轉置游標周圍的字元數",
		"轉換到大寫",
		"轉換到小寫",
		"轉換為字首大寫",
		"轉換為底線連接字",
		"轉換為 Camel 案例",
		"轉換成 Kebab Case",
	],
	"vs/editor/contrib/linkedEditing/browser/linkedEditing": [
		"開始連結的編輯",
		"當編輯器自動重新命名類型時的背景色彩。",
	],
	"vs/editor/contrib/links/browser/links": [
		"因為此連結的格式不正確，所以無法開啟: {0}",
		"因為此連結目標遺失，所以無法開啟。",
		"執行命令",
		"追蹤連結",
		"cmd + 按一下",
		"ctrl + 按一下",
		"選項 + 按一下",
		"alt + 按一下",
		"執行命令 {0}",
		"開啟連結",
	],
	"vs/editor/contrib/message/browser/messageController": [
		"編輯器目前是否正在顯示內嵌訊息",
	],
	"vs/editor/contrib/multicursor/browser/multicursor": [
		"新增的資料指標: {0}",
		"新增的資料指標: {0}",
		"在上方加入游標",
		"在上方新增游標(&&A)",
		"在下方加入游標",
		"在下方新增游標(&&D)",
		"在行尾新增游標",
		"在行尾新增游標(&&U)",
		"將游標新增到底部 ",
		"將游標新增到頂部",
		"將選取項目加入下一個找到的相符項",
		"新增下一個項目(&&N)",
		"將選取項目加入前一個找到的相符項中",
		"新增上一個項目(&&R)",
		"將最後一個選擇項目移至下一個找到的相符項",
		"將最後一個選擇項目移至前一個找到的相符項",
		"選取所有找到的相符項目",
		"選取所有項目(&&O)",
		"變更所有發生次數",
		"聚焦下一個游標",
		"聚焦下一個游標",
		"聚焦上一個游標",
		"聚焦前一個游標",
	],
	"vs/editor/contrib/parameterHints/browser/parameterHints": [
		"觸發參數提示",
	],
	"vs/editor/contrib/parameterHints/browser/parameterHintsWidget": [
		"[顯示下一個參數提示] 的圖示。",
		"[顯示上一個參數提示] 的圖示。",
		"{0}，提示",
		"參數提示中使用中項目的前景色彩。",
	],
	"vs/editor/contrib/peekView/browser/peekView": [
		"目前的程式碼編輯器是否內嵌於瞄核內",
		"關閉",
		"預覽檢視標題區域的背景色彩。",
		"預覽檢視標題的色彩。",
		"預覽檢視標題資訊的色彩。",
		"預覽檢視之框線與箭頭的色彩。",
		"預覽檢視中結果清單的背景色彩。",
		"預覽檢視結果列表中行節點的前景色彩",
		"預覽檢視結果列表中檔案節點的前景色彩",
		"在預覽檢視之結果清單中選取項目時的背景色彩。",
		"在預覽檢視之結果清單中選取項目時的前景色彩。",
		"預覽檢視編輯器的背景色彩。",
		"預覽檢視編輯器邊框(含行號或字形圖示)的背景色彩。",
		"預覽檢視編輯器中黏性滾動的背景色彩。",
		"在預覽檢視編輯器中比對時的反白顯示色彩。",
		"預覽檢視編輯器中比對時的反白顯示色彩。",
		"在預覽檢視編輯器中比對時的反白顯示邊界。",
	],
	"vs/editor/contrib/quickAccess/browser/gotoLineQuickAccess": [
		"先開啟文字編輯器，前往某一行。",
		"前往第 {0} 行的第 {1} 個字元。",
		"前往第 {0} 行。",
		"目前行: {0}，字元: {1}。請鍵入介於 1 到 {2} 之間行號，導覽至該行。",
		"目前行: {0}，字元: {1}。請鍵入要導覽至的行號。",
	],
	"vs/editor/contrib/quickAccess/browser/gotoSymbolQuickAccess": [
		"若要前往符號，請先開啟包含符號資訊的文字編輯器。",
		"使用中的文字編輯器不提供符號資訊。",
		"沒有相符的編輯器符號",
		"沒有編輯器符號",
		"開至側邊",
		"開啟到底部",
		"符號 ({0})",
		"屬性 ({0})",
		"方法 ({0})",
		"函式 ({0})",
		"建構函式 ({0})",
		"變數 ({0})",
		"類別 ({0})",
		"結構 ({0})",
		"事件 ({0})",
		"運算子 ({0})",
		"介面 ({0})",
		"命名空間 ({0})",
		"套件 ({0})",
		"型別參數 ({0})",
		"模組 ({0})",
		"屬性 ({0})",
		"列舉 ({0})",
		"列舉成員 ({0})",
		"字串 ({0})",
		"檔案 ({0})",
		"陣列 ({0})",
		"數字 ({0})",
		"布林值 ({0})",
		"物件 ({0})",
		"索引鍵 ({0})",
		"欄位 ({0})",
		"常數 ({0})",
	],
	"vs/editor/contrib/readOnlyMessage/browser/contribution": [
		"無法在唯讀輸入中編輯",
		"無法在唯讀編輯器中編輯",
	],
	"vs/editor/contrib/rename/browser/rename": [
		"沒有結果。",
		"解析重新命名位置時發生未知的錯誤",
		"正在將 \'{0}\' 重新命名為 \'{1}\'",
		"正在將 {0} 重新命名為 {1}",
		"已成功將 \'{0}\' 重新命名為 \'{1}\'。摘要: {2}",
		"重命名無法套用編輯",
		"重新命名無法計算編輯",
		"重新命名符號",
		"啟用/停用重新命名前先預覽變更的功能",
	],
	"vs/editor/contrib/rename/browser/renameInputField": [
		"是否顯示重新命名輸入小工具",
		"為輸入重新命名。請鍵入新名稱，然後按 Enter 以提交。",
		"按 {0} 進行重新命名，按 {1} 進行預覽",
	],
	"vs/editor/contrib/smartSelect/browser/smartSelect": [
		"展開選取項目",
		"展開選取範圍(&&E)",
		"縮小選取項目",
		"壓縮選取範圍(&&S)",
	],
	"vs/editor/contrib/snippet/browser/snippetController2": [
		"編輯器目前是否在程式碼片段模式中",
		"在程式碼片段模式中是否有下一個定位停駐點",
		"在程式碼片段模式中是否有上一個定位停駐點",
		"移至下一個預留位置...",
	],
	"vs/editor/contrib/snippet/browser/snippetVariables": [
		"星期天",
		"星期一",
		"星期二",
		"星期三",
		"星期四",
		"星期五",
		"星期六",
		"週日",
		"週一",
		"週二",
		"週三",
		"週四",
		"週五",
		"週六",
		"一月",
		"二月",
		"三月",
		"四月",
		"五月",
		"六月",
		"七月",
		"八月",
		"九月",
		"十月",
		"十一月",
		"十二月",
		"1月",
		"2月",
		"3 月",
		"4月",
		"五月",
		"6月",
		"7 月",
		"8 月",
		"9 月",
		"10 月",
		"11 月",
		"12 月",
	],
	"vs/editor/contrib/stickyScroll/browser/stickyScrollActions": [
		"切換自黏捲動",
		"切換自黏捲動(&&T)",
		"自黏捲動",
		"自黏捲動(&&S)",
		"聚焦自黏捲動",
		"焦點自黏捲動(&&F)",
		"選取下一個自黏捲動行",
		"選取上一個自黏捲動行",
		"移至聚焦的自黏捲動行",
		"選取編輯器",
	],
	"vs/editor/contrib/suggest/browser/suggest": [
		"是否聚焦任何建議",
		"是否顯示建議詳細資料",
		"是否有多個建議可以挑選",
		"插入目前的建議會產生變更，或已鍵入所有項目",
		"是否在按下 Enter 時插入建議",
		"目前的建議是否有插入和取代行為",
		"預設行為是插入或取代",
		"目前的建議是否支援解決更多詳細資料",
	],
	"vs/editor/contrib/suggest/browser/suggestController": [
		"接受 ‘{0}’ 進行了其他 {1} 項編輯",
		"觸發建議",
		"插入",
		"插入",
		"取代",
		"取代",
		"插入",
		"顯示更少",
		"顯示更多",
		"重設建議小工具大小",
	],
	"vs/editor/contrib/suggest/browser/suggestWidget": [
		"建議小工具的背景色彩。",
		"建議小工具的邊界色彩。",
		"建議小工具的前景色彩。",
		"建議小工具中所選項目的前景色彩。",
		"建議小工具中所選項目的圖示前景色彩。",
		"建議小工具中所選項目的背景色彩。",
		"建議小工具中相符醒目提示的色彩。",
		"當項目成為焦點時，相符項目的色彩在建議小工具中會醒目顯示。",
		"建議小工具狀態的前景色彩。",
		"正在載入...",
		"無建議。",
		"建議",
		"{0} {1}，{2}",
		"{0} {1}",
		"{0}，{1}",
		"{0}，文件: {1}",
	],
	"vs/editor/contrib/suggest/browser/suggestWidgetDetails": [
		"關閉",
		"正在載入...",
	],
	"vs/editor/contrib/suggest/browser/suggestWidgetRenderer": [
		"建議小工具中 [更多詳細資訊] 的圖示。",
		"閱讀更多",
	],
	"vs/editor/contrib/suggest/browser/suggestWidgetStatus": [
		"{0} ({1})",
	],
	"vs/editor/contrib/symbolIcons/browser/symbolIcons": [
		"陣列符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"布林值符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"類別符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"色彩符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"常數符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"建構函式符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"列舉值符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"列舉值成員符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"事件符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"欄位符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"檔案符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"資料夾符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"函式符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"介面符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"索引鍵符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"關鍵字符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"方法符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"模組符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"命名空間符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"Null 符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"數字符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"物件符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"運算子符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"套件符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"屬性符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"參考符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"程式碼片段符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"字串符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"結構符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"文字符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"型別參數符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"單位符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
		"變數符號的前景色彩。這些符號會出現在大綱、階層連結和建議小工具中。",
	],
	"vs/editor/contrib/toggleTabFocusMode/browser/toggleTabFocusMode": [
		"切換 TAB 鍵移動焦點",
		"按 Tab 現在會將焦點移至下一個可設定焦點的元素。",
		"按 Tab 現在會插入定位字元。",
	],
	"vs/editor/contrib/tokenization/browser/tokenization": [
		"開發人員: 強制重新置放",
	],
	"vs/editor/contrib/unicodeHighlighter/browser/unicodeHighlighter": [
		"延伸模組編輯器中顯示含有警告訊息的圖示。",
		"此文件包含許多非基本 ASCII Unicode 字元",
		"此文件包含許多不明確的 Unicode 字元",
		"此文件包含許多隱藏的 Unicode 字元",
		"字元 {0} 可能與 ASCII 字元 {1} 混淆，這在原始程式碼中比較常見。",
		"字元 {0} 可能與字元 {1} 混淆，這在原始程式碼中比較常見。",
		"字元 {0} 隱藏。",
		"字元 {0} 不是基本的 ASCII 字元。",
		"調整設定",
		"停用註解中的醒目提示",
		"停用註解中字元的醒目提示",
		"停用字串中的醒目提示",
		"停用字串中字元的醒目提示",
		"停用不明確的醒目提示",
		"停用不明確字元的醒目提示",
		"停用隱藏醒目提示",
		"停用隱藏字元的醒目提示",
		"停用非 ASCII 醒目提示",
		"停用非基本 ASCII 字元的醒目提示",
		"顯示排除選項",
		"排除 {0} (隱藏字元) 的反白顯示",
		"將 {0} 排除在已醒目提示",
		"允許在語言「{0}」中較常用的 Unicode 字元。",
		"設定 Unicode 醒目提示選項",
	],
	"vs/editor/contrib/unusualLineTerminators/browser/unusualLineTerminators": [
		"異常的行結束字元",
		"偵測到異常的行結束字元",
		"檔案 \'{0}\' 包含一或多個異常的行結束字元，例如行分隔符號 (LS) 或段落分隔符號 (PS)。\r\n\r\n建議您將其從檔案中移除。這可以透過 `editor.unusualLineTerminators` 進行設定。",
		"移除異常的行結束字元(&&R)",
		"忽略",
	],
	"vs/editor/contrib/wordHighlighter/browser/highlightDecorations": [
		"讀取權限期間 (如讀取變數) 符號的背景色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"寫入權限期間 (如寫入變數) 符號的背景色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"符號文字出現的背景色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"讀取存取期間 (例如讀取變數時) 符號的邊框顏色。",
		"寫入存取期間 (例如寫入變數時) 符號的邊框顏色。 ",
		"符號文字出現的框線色彩。",
		"符號醒目提示的概觀尺規標記色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"寫入權限符號醒目提示的概觀尺規標記色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"符號文字出現的概觀尺規標記色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
	],
	"vs/editor/contrib/wordHighlighter/browser/wordHighlighter": [
		"移至下一個反白符號",
		"移至上一個反白符號",
		"觸發符號反白顯示",
	],
	"vs/editor/contrib/wordOperations/browser/wordOperations": [
		"刪除字組",
	],
	"vs/platform/action/common/actionCommonCategories": [
		"檢視",
		"說明",
		"測試",
		"檔案",
		"喜好設定",
		"開發人員",
	],
	"vs/platform/actionWidget/browser/actionList": [
		"{0} 以套用，{1} 以預覽",
		"{0} 以申請",
		"{0}，停用原因: {1}",
		"動作小工具",
	],
	"vs/platform/actionWidget/browser/actionWidget": [
		"Background color for toggled action items in action bar.",
		"是否顯示動作小工具清單",
		"隱藏動作小工具",
		"選取上一個動作",
		"選取下一個動作",
		"接受選取的動作",
		"預覽選取的動作",
	],
	"vs/platform/actions/browser/menuEntryActionViewItem": [
		"{0} ({1})",
		"{0} ({1})",
		"{0}\r\n[{1}] {2}",
	],
	"vs/platform/actions/browser/toolbar": [
		"隱藏",
		"重設功能表",
	],
	"vs/platform/actions/common/menuService": [
		"隱藏 \'{0}\'",
	],
	"vs/platform/audioCues/browser/audioCueService": [
		"行上發生錯誤",
		"行上的警告",
		"行上的摺疊區域",
		"行上的中斷點",
		"行上的內嵌建議",
		"終端機快速修正",
		"在中斷點停止偵錯工具",
		"行上沒有嵌入提示",
		"工作完成",
		"工作失敗",
		"終端機命令失敗",
		"終端鈴",
		"Notebook 儲存格已完成",
		"Notebook 儲存格失敗",
		"差異行已插入",
		"差異行已刪除",
		"差異行已修改",
		"聊天要求已傳送",
		"聊天回應已接收",
		"聊天回應擱置中",
	],
	"vs/platform/configuration/common/configurationRegistry": [
		"預設語言組態覆寫",
		"設定要針對 {0} 語言覆寫的設定。",
		"設定要針對語言覆寫的編輯器設定。",
		"這個設定不支援以語言為根據的組態。",
		"設定要針對語言覆寫的編輯器設定。",
		"這個設定不支援以語言為根據的組態。",
		"無法註冊空白屬性",
		"無法註冊 \'{0}\'。這符合用於描述語言專用編輯器設定的屬性模式 \'\\\\[.*\\\\]$\'。請使用 \'configurationDefaults\' 貢獻。",
		"無法註冊 \'{0}\'。此屬性已經註冊。",
		"無法註冊 \'{0}\'。已向 {2} 註冊關聯的原則 {1}。",
	],
	"vs/platform/contextkey/browser/contextKeyService": [
		"傳回有關內容索引鍵資訊的命令",
	],
	"vs/platform/contextkey/common/contextkey": [
		"空的內容索引鍵運算式",
		"您是否忘記撰寫運算式? 您也可以分別放置 \'false\' 或 \'true\'，以一律評估為 False 或 True。",
		"\'not\' 後為 \'in\'。",
		"右括弧 \')\'",
		"未預期的權杖",
		"您是否忘記在權杖之前放置 && 或 ||?",
		"運算式未預期的結尾",
		"您是否忘記放置內容金鑰?",
		"預期: {0}\r\n收到: \'{1}\'。",
	],
	"vs/platform/contextkey/common/contextkeys": [
		"作業系統是否為 macOS",
		"作業系統是否為 Linux",
		"作業系統是否為 Windows",
		"平台是否為網頁瀏覽器",
		"非瀏覽器平台上的作業系統是否為 macOS",
		"作業系統是否為 iOS",
		"平臺是否為行動網頁瀏覽器",
		"VS Code 的品質類型",
		"鍵盤焦點是否位於輸入方塊內",
	],
	"vs/platform/contextkey/common/scanner": [
		"您是指 \'{0}\'?",
		"您是指 {0} 或 {1}?",
		"您是指 {0}、{1} 或 {2}?",
		"您是否忘記左括弧或右括弧?",
		"您是否忘記逸出 \'/\' (斜線) 字元? 在反斜線前放兩個反斜線以逸出，例如 \'\\\\/\'。",
	],
	"vs/platform/history/browser/contextScopedHistoryWidget": [
		"是否顯示建議",
	],
	"vs/platform/keybinding/common/abstractKeybindingService": [
		"已按下 ({0})。等待第二個套索鍵...",
		"({0}) 已按下。正在等待下一個套索鍵...",
		"按鍵組合 ({0}, {1}) 不是命令。",
		"按鍵組合 ({0}, {1}) 不是命令。",
	],
	"vs/platform/list/browser/listService": [
		"工作台",
		"對應Windows和Linux的\'Control\'與對應 macOS 的\'Command\'。",
		"對應Windows和Linux的\'Alt\'與對應macOS的\'Option\'。",
		"透過滑鼠多選，用於在樹狀目錄與清單中新增項目的輔助按鍵 (例如在總管中開啟編輯器 及 SCM 檢視)。\'在側邊開啟\' 滑鼠手勢 (若支援) 將會適應以避免和多選輔助按鍵衝突。",
		"控制如何使用滑鼠 (如支援此用法) 開啟樹狀目錄與清單中的項目。若不適用，某些樹狀目錄與清單可能會選擇忽略此設定。",
		"控制在工作台中，清單與樹狀結構是否支援水平捲動。警告: 開啟此設定將會影響效能。",
		"控制按一下捲軸是否逐頁捲動。",
		"控制樹狀結構縮排 (像素)。",
		"控制樹系是否應轉譯縮排輔助線。",
		"控制清單和樹狀結構是否具有平滑捲動。",
		"要用於滑鼠滾輪捲動事件 `deltaX` 和 `deltaY` 的乘數。",
		"按下 `Alt` 時的捲動速度乘數。",
		"搜尋時會醒目提示元素。進一步的向上和向下瀏覽只會周遊已醒目提示的元素。",
		"搜尋時篩選元素。",
		"控制 Workbench 中清單和樹狀結構的預設尋找模式。",
		"比對按鍵輸入的簡易按鍵瀏覽焦點元素。僅比對前置詞。",
		"醒目提示鍵盤瀏覽會醒目提示符合鍵盤輸入的元素。進一步向上或向下瀏覽只會周遊醒目提示的元素。",
		"篩選鍵盤瀏覽會篩掉並隱藏不符合鍵盤輸入的所有元素。",
		"控制 Workbench 中清單和樹狀結構的鍵盤瀏覽樣式。可以是簡易的、醒目提示和篩選。",
		"請改為使用 \'workbench.list.defaultFindMode\' 和 \'workbench.list.typeNavigationMode\'。",
		"搜尋時使用模糊比對。",
		"搜尋時使用連續比對。",
		"控制在工作台中搜尋清單和樹狀結構時所使用的比對類型。",
		"控制當按下資料夾名稱時，樹狀目錄資料夾的展開方式。請注意，若不適用，某些樹狀目錄和清單可能會選擇忽略此設定。",
		"控制工作台中清單和樹狀目錄的類型瀏覽運作方式。設定為 \'trigger\' 時，類型瀏覽會在執行 \'list.triggerTypeNavigation\' 命令時隨即開始。",
	],
	"vs/platform/markers/common/markers": [
		"錯誤",
		"警告",
		"資訊",
	],
	"vs/platform/quickinput/browser/commandsQuickAccess": [
		"最近使用的",
		"經常使用",
		"其他命令",
		"{0}, {1}",
		"命令 \'{0}\' 造成錯誤",
	],
	"vs/platform/quickinput/browser/helpQuickAccess": [
		"{0}, {1}",
	],
	"vs/platform/quickinput/browser/quickInput": [
		"上一頁",
		"按 \'Enter\' 鍵確認您的輸入或按 \'Esc\' 鍵取消",
		"{0}/{1}",
		"輸入以縮小結果範圍。",
	],
	"vs/platform/quickinput/browser/quickInputController": [
		"Toggle all checkboxes",
		"{0} Results",
		"{0} Selected",
		"OK",
		"Custom",
		"Back ({0})",
		"Back",
	],
	"vs/platform/quickinput/browser/quickInputList": [
		"快速輸入",
	],
	"vs/platform/quickinput/browser/quickInputUtils": [
		"按一下以執行命令 ‘{0}’",
	],
	"vs/platform/theme/common/colorRegistry": [
		"整體的前景色彩。僅當未被任何元件覆疊時，才會使用此色彩。",
		"已停用元素的整體前景。只有在元件未覆蓋時，才能使用這個色彩。",
		"整體錯誤訊息的前景色彩。僅當未被任何元件覆蓋時，才會使用此色彩。",
		"提供附加訊息的前景顏色,例如標籤",
		"工作台中圖示的預設色彩。",
		"焦點項目的整體框線色彩。只在沒有任何元件覆寫此色彩時，才會加以使用。",
		"項目周圍的額外框線，可將項目從其他項目中區隔出來以提高對比。",
		"使用中項目周圍的額外邊界，可將項目從其他項目中區隔出來以提高對比。",
		"作業區域選取的背景顏色(例如輸入或文字區域)。請注意，這不適用於編輯器中的選取。",
		"文字分隔符號的顏色。",
		"內文連結的前景色彩",
		"當滑鼠點擊或懸停時，文字中連結的前景色彩。",
		"提示及建議文字的前景色彩。",
		"文內引用區塊背景色彩。",
		"引用文字的框線顏色。",
		"文字區塊的背景顏色。",
		"小工具的陰影色彩，例如編輯器中的尋找/取代。",
		"小工具的框線色彩，例如編輯器中的尋找/取代。",
		"輸入方塊的背景。",
		"輸入方塊的前景。",
		"輸入方塊的框線。",
		"輸入欄位中可使用之項目的框線色彩。",
		"在輸入欄位中所啟動選項的背景色彩。",
		"輸入欄位中選項的背景暫留色彩。",
		"在輸入欄位中所啟動選項的前景色彩。",
		"文字輸入替代字符的前景顏色。",
		"資訊嚴重性的輸入驗證背景色彩。",
		"資訊嚴重性的輸入驗證前景色彩。",
		"資訊嚴重性的輸入驗證邊界色彩。",
		"警告嚴重性的輸入驗證背景色彩。",
		"警告嚴重性的輸入驗證前景色彩。",
		"警告嚴重性的輸入驗證邊界色彩。",
		"錯誤嚴重性的輸入驗證背景色彩。",
		"錯誤嚴重性的輸入驗證前景色彩。",
		"錯誤嚴重性的輸入驗證邊界色彩。",
		"下拉式清單的背景。",
		"下拉式清單的背景。",
		"下拉式清單的前景。",
		"下拉式清單的框線。",
		"按鈕前景色彩。",
		"分隔線色彩按鈕。",
		"按鈕背景色彩。",
		"暫留時的按鈕背景色彩。",
		"按鈕框線色彩。",
		"次要按鈕前景色彩。",
		"次要按鈕背景色彩。",
		"滑鼠暫留時的次要按鈕背景色彩。",
		"標記的背景顏色。標記為小型的訊息標籤,例如搜尋結果的數量。",
		"標記的前景顏色。標記為小型的訊息標籤,例如搜尋結果的數量。",
		"指出在捲動該檢視的捲軸陰影。",
		"捲軸滑桿的背景顏色。",
		"動態顯示時捲軸滑桿的背景顏色。",
		"當點擊時捲軸滑桿的背景顏色。",
		"長時間運行進度條的背景色彩.",
		"編輯器中錯誤文字的背景色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"編輯器內錯誤提示線的前景色彩.",
		"如果設定，編輯器中的錯誤會顯示雙底線色彩。",
		"編輯器中警告文字的背景色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"編輯器內警告提示線的前景色彩.",
		"如果設定，編輯器中的警告會顯示雙底線色彩。",
		"編輯器中資訊文字的背景色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"編輯器內資訊提示線的前景色彩",
		"如果設定，編輯器中的提示會顯示雙底線色彩。",
		"編輯器內提示訊息的提示線前景色彩",
		"如果設定，編輯器中的提示會顯示雙底線色彩。",
		"使用中飾帶的框線色彩。",
		"編輯器的背景色彩。",
		"編輯器的預設前景色彩。",
		"編輯器的黏滯卷軸背景色彩",
		"編輯器的游標背景色彩上的黏滯卷軸",
		"編輯器小工具的背景色彩，例如尋找/取代。",
		"編輯器小工具 (例如尋找/取代) 的前景色彩。",
		"編輯器小工具的邊界色彩。小工具選擇擁有邊界或色彩未被小工具覆寫時，才會使用色彩。",
		"編輯器小工具之調整大小列的邊界色彩。只在小工具選擇具有調整大小邊界且未覆寫該色彩時，才使用該色彩。",
		"快速選擇器背景色彩。該快速選擇器小工具是類似命令選擇區的選擇器容器。",
		"快速選擇器前景色彩。快速選擇器小工具是類似命令選擇區等選擇器的容器。",
		"快速選擇器標題背景色彩。快速選擇器小工具是類似命令選擇區的選擇器容器。",
		"分組標籤的快速選擇器色彩。",
		"分組邊界的快速選擇器色彩。",
		"金鑰綁定標籤背景色彩。按鍵綁定標籤用來代表鍵盤快速鍵。",
		"金鑰綁定標籤前景色彩。按鍵綁定標籤用來代表鍵盤快速鍵。",
		"金鑰綁定標籤邊框色彩。按鍵綁定標籤用來代表鍵盤快速鍵。",
		"金鑰綁定標籤邊框底部色彩。按鍵綁定標籤用來代表鍵盤快速鍵。",
		"編輯器選取範圍的色彩。",
		"為選取的文字顏色高對比化",
		"非使用中編輯器內的選取項目色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"與選取項目內容相同之區域的色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"選取時，內容相同之區域的框線色彩。",
		"符合目前搜尋的色彩。",
		"其他搜尋相符項目的色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"限制搜尋之範圍的色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"符合目前搜尋的框線色彩。",
		"符合其他搜尋的框線色彩。",
		"限制搜尋之範圍的框線色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"搜尋編輯器查詢符合的色彩。",
		"搜索編輯器查詢符合的邊框色彩。",
		"搜尋 Viewlet 完成訊息中文字的色彩。",
		"在顯示動態顯示的文字下醒目提示。其不得為不透明色彩，以免隱藏底層裝飾。",
		"編輯器動態顯示的背景色彩。",
		"編輯器動態顯示的前景色彩。",
		"編輯器動態顯示的框線色彩。",
		"編輯器暫留狀態列的背景色彩。",
		"使用中之連結的色彩。",
		"內嵌提示的前景色彩",
		"內嵌提示的背景色彩",
		"類型內嵌提示的前景色彩",
		"類型內嵌提示的背景色彩",
		"參數內嵌提示的前景色彩",
		"參數內嵌提示的背景色彩",
		"用於燈泡動作圖示的色彩。",
		"用於燈泡自動修正動作圖示的色彩。",
		"已插入文字的背景色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"已移除文字的背景色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"已插入程式行的背景色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"已移除程式行的背景色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"插入程式行所在邊界的背景色彩。",
		"移除程式行所在邊界的背景色彩。",
		"插入內容的差異概觀尺規前景。",
		"移除內容的差異概觀尺規前景。",
		"插入的文字外框色彩。",
		"移除的文字外框色彩。",
		"兩個文字編輯器之間的框線色彩。",
		"Diff 編輯器的斜紋填滿色彩。斜紋填滿用於並排 Diff 檢視。",
		"Diff 編輯器中未變更區塊的背景色彩。",
		"Diff 編輯器中未變更區塊的前景色彩。",
		"Diff 編輯器中未變更程式碼的背景色彩。",
		"當清單/樹狀為使用中狀態時，焦點項目的清單/樹狀背景色彩。使用中的清單/樹狀有鍵盤焦點，非使用中者則沒有。",
		"當清單/樹狀為使用中狀態時，焦點項目的清單/樹狀前景色彩。使用中的清單/樹狀有鍵盤焦點，非使用中者則沒有。",
		"當清單/樹狀目錄為使用中狀態時，焦點項目的清單/樹狀目錄外框色彩。使用中的清單/樹狀目錄有鍵盤焦點，非使用中者則沒有。",
		"當清單/樹狀目錄為使用中狀態並已選取時，焦點項目的清單/樹狀目錄外框色彩。使用中的清單/樹狀目錄具有鍵盤焦點，非使用中者則沒有。",
		"當清單/樹狀為使用中狀態時，所選項目的清單/樹狀背景色彩。使用中的清單/樹狀有鍵盤焦點，非使用中者則沒有。",
		"當清單/樹狀為使用中狀態時，所選項目的清單/樹狀前景色彩。使用中的清單/樹狀有鍵盤焦點，非使用中者則沒有。",
		"當清單/樹狀為使用中狀態時，所選項目的清單/樹狀圖示前景色彩。使用中的清單/樹狀有鍵盤焦點，非使用中者則沒有。",
		"當清單/樹狀為非使用中狀態時，所選項目的清單/樹狀背景色彩。使用中的清單/樹狀有鍵盤焦點，非使用中者則沒有。",
		"當清單/樹狀為使用中狀態時，所選項目的清單/樹狀前景色彩。使用中的清單/樹狀有鍵盤焦點，非使用中則沒有。",
		"當清單/樹狀為非使用中狀態時，所選項目的清單/樹狀圖示前景色彩。使用中的清單/樹狀有鍵盤焦點，非使用中者則沒有。",
		"當清單/樹狀為非使用中狀態時，焦點項目的清單/樹狀背景色彩。使用中的清單/樹狀有鍵盤焦點，非使用中者則沒有。",
		"當清單/樹狀目錄為非使用中狀態時，焦點項目的清單/樹狀目錄外框色彩。使用中的清單/樹狀目錄有鍵盤焦點，非使用中者則沒有。",
		"使用滑鼠暫留在項目時的清單/樹狀背景。",
		"滑鼠暫留在項目時的清單/樹狀前景。",
		"使用滑鼠四處移動項目時的清單/樹狀拖放背景。",
		"在清單/樹狀內搜尋時，相符醒目提示的清單/樹狀前景色彩。",
		"在清單/樹狀內搜尋時，相符項目的清單/樹狀結構前景色彩會針對主動焦點項目進行強調顯示。",
		"列表/樹狀 無效項目的前景色彩，例如在瀏覽視窗無法解析的根目錄",
		"包含錯誤清單項目的前景色彩",
		"包含警告清單項目的前景色彩",
		"清單和樹狀結構中類型篩選小工具的背景色彩。",
		"清單和樹狀結構中類型篩選小工具的大綱色彩。",
		"在沒有相符項目時，清單和樹狀結構中類型篩選小工具的大綱色彩。",
		"清單和樹狀結構中類型篩選小工具的陰影色彩。",
		"已篩選相符項的背景色彩。",
		"已篩選相符項的框線色彩。",
		"縮排輔助線的樹狀筆觸色彩。",
		"非使用中縮排輔助線的樹狀筆觸色彩。",
		"資料行之間的資料表邊界色彩。",
		"奇數資料表資料列的背景色彩。",
		"已取消強調的清單/樹狀結構前景色彩。",
		"核取方塊小工具的背景色彩。",
		"選取其所處元素時，核取方塊小工具的背景色彩。",
		"核取方塊小工具的前景色彩。",
		"核取方塊小工具的框線色彩。",
		"選取其所處元素時，核取方塊小工具的框線色彩。",
		"請改用 quickInputList.focusBackground",
		"焦點項目的快速選擇器前景色彩。",
		"焦點項目的快速選擇器圖示前景色彩。",
		"焦點項目的快速選擇器背景色彩。",
		"功能表的邊框色彩。",
		"功能表項目的前景色彩。",
		"功能表項目的背景色彩。",
		"功能表中所選功能表項目的前景色彩。",
		"功能表中所選功能表項目的背景色彩。",
		"功能表中所選功能表項目的框線色彩。",
		"功能表中分隔線功能表項目的色彩。",
		"使用滑鼠將游標停留在動作上方時的工具列背景",
		"使用滑鼠將游標停留在動作上方時的工具列外框",
		"將滑鼠移到動作上方時的工具列背景",
		"程式碼片段定位停駐點的反白顯示背景色彩。",
		"程式碼片段定位停駐點的反白顯示邊界色彩。",
		"程式碼片段最終定位停駐點的反白顯示背景色彩。",
		"程式碼片段最終定位停駐點的醒目提示框線色彩。",
		"焦點階層連結項目的色彩。",
		"階層連結的背景色。",
		"焦點階層連結項目的色彩。",
		"所選階層連結項目的色彩。",
		"階層連結項目選擇器的背景色彩。",
		"內嵌合併衝突中目前的標頭背景。其不得為不透明色彩，以免隱藏底層裝飾。",
		"內嵌合併衝突中的目前內容背景。其不得為不透明色彩，以免隱藏底層裝飾。",
		"內嵌合併衝突中的傳入標頭背景。其不得為不透明色彩，以免隱藏底層裝飾。",
		"內嵌合併衝突中的傳入內容背景。其不得為不透明色彩，以免隱藏底層裝飾。",
		"內嵌合併衝突中的一般上階標頭背景。其不得為不透明色彩，以免隱藏底層裝飾。",
		"內嵌合併衝突中的一般上階內容背景。其不得為不透明色彩，以免隱藏底層裝飾。",
		"內嵌合併衝突中標頭及分隔器的邊界色彩。",
		"目前內嵌合併衝突的概觀尺規前景。",
		"傳入內嵌合併衝突的概觀尺規前景。",
		"內嵌合併衝突中的共同上階概觀尺規前景。",
		"尋找相符項目的概觀尺規標記色彩。其不得為不透明色彩，以免隱藏底層裝飾。",
		"選取項目醒目提示的概觀尺規標記。其不得為不透明色彩，以免隱藏底層裝飾。",
		"用於尋找相符項目的縮圖標記色彩。",
		"重複編輯器選取項目的縮圖標記色彩。",
		"編輯器選取範圍的迷你地圖標記色彩。",
		"錯誤的縮圖標記色彩。",
		"警告的縮圖標記色彩。",
		"縮圖背景色彩。",
		"在縮圖中呈現的前景元素不透明度。例如，\"#000000c0\" 會以不透明度 75% 轉譯元素。",
		"縮圖滑桿背景色彩。",
		"暫留時的縮圖滑桿背景色彩。",
		"按一下時的縮圖滑桿背景色彩。",
		"用於問題錯誤圖示的色彩。",
		"用於問題警告圖示的色彩。",
		"用於問題資訊圖示的色彩。",
		"圖表中使用的前景色彩。",
		"用於圖表中水平線的色彩。",
		"圖表視覺效果中所使用的紅色。",
		"圖表視覺效果中所使用的藍色。",
		"圖表視覺效果中所使用的黃色。",
		"圖表視覺效果中所使用的橙色。",
		"圖表視覺效果中所使用的綠色。",
		"圖表視覺效果中所使用的紫色。",
	],
	"vs/platform/theme/common/iconRegistry": [
		"要使用的字型識別碼。如未設定，就會使用最先定義的字型。",
		"與圖示定義建立關聯的字型字元。",
		"小工具中關閉動作的圖示。",
		"移至上一個編輯器位置的圖示。",
		"移至下一個編輯器位置的圖示。",
	],
	"vs/platform/undoRedo/common/undoRedoService": [
		"已在磁碟上關閉並修改以下檔案: {0}。",
		"下列檔案已使用不相容的方式修改: {0}。",
		"無法復原所有檔案的 \'{0}\'。{1}",
		"無法復原所有檔案的 \'{0}\'。{1}",
		"因為已對 {1} 進行變更，所以無法復原所有檔案的 \'{0}\'",
		"因為 {1} 中已經有正在執行的復原或重做作業，所以無法為所有檔案復原 \'{0}\'",
		"因為同時發生其他復原或重做作業，所以無法為所有檔案復原 \'{0}\'",
		"要復原所有檔案的 \'{0}\' 嗎?",
		"在 {0} 個檔案中復原(&&U)",
		"復原此檔案(&&F)",
		"因為已經有正在執行的復原或重做作業，所以無法復原 \'{0}\'。",
		"要復原 \'{0}\' 嗎?",
		"是(&&Y)",
		"否",
		"無法復原所有檔案的 \'{0}\'。{1}",
		"無法復原所有檔案的 \'{0}\'。{1}",
		"因為已對 {1} 進行變更，所以無法復原所有檔案的 \'{0}\'",
		"因為 {1} 中已經有正在執行的復原或重做作業，所以無法為所有檔案重做 \'{0}\'",
		"因為同時發生其他復原或重做作業，所以無法為所有檔案重做 \'{0}\'",
		"因為已經有正在執行的復原或重做作業，所以無法重做 \'{0}\'。",
	],
	"vs/platform/workspace/common/workspace": [
		"Code 工作區",
	]
});